import { useState } from "react";
import { faqs } from "@/mocks/gossip";

interface FaqSectionProps {
  items?: { q: string; a: string }[];
  id?: string;
  title?: string;
  desc?: string;
}

export default function FaqSection({
  items = faqs,
  id = "faq",
  title = "常见问题",
  desc = "关于内容来源、榜单计算与投稿方式，这里先解答最常见的几个疑问。",
}: FaqSectionProps) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id={id} className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <p className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-primary-600 mb-3">
              <span className="w-6 h-px bg-primary-500 inline-block"></span>
              FAQ
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
            <div className="mt-6 flex items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200">
              <span className="w-9 h-9 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
                <i className="ri-customer-service-2-line" aria-hidden="true"></i>
              </span>
              <p className="text-sm text-foreground-600 leading-relaxed">
                还有其它疑问？可通过页面底部邮箱联系我们，工作日内会尽快回复。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {items.map((item, index) => {
                const isOpen = open === index;
                return (
                  <li
                    key={item.q}
                    className={`rounded-lg border transition-colors ${
                      isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                    }`}
                  >
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? null : index)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                        {item.q}
                      </span>
                      <span
                        className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-lg transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 -mt-1">
                        <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}